/*
 * @Author: changcheng
 * @LastEditTime: 2023-11-15 15:51:21
 */
import { store } from "@root/store/index";
export default function IframeComponent() {
  const { bannerInfo } = store.getState();
  const { title, url } = bannerInfo;
  return <iframe src={url} width={"100%"} height={"100%"} title={title} />;
}
